export default __webpack_public_path__ + "static/hero-koi-collage-bg-6c84f374b9a45e7d098c0903d2774f85.png";